import { Box, Grid, Stack, Tooltip } from '@mui/material';
import React from 'react';
import { WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

import { RecruiterAvatarGroup } from './RecruiterAvatarGroup';

export const RecruiterAvatarGroupInfo = ({ title, list, Icon }) => (
  <Grid item xs={4}>
    <Stack direction="row" spacing={1} ml="-11px" alignItems="center">
      <Tooltip title={title} placement="top">
        <Box component="span" height="1.25em">
          <Icon size={20} />
        </Box>
      </Tooltip>
      {list?.length === 0 ? (
        <WsTypography color={WsTypoColors.WHITE} variant={WsTypoVariants.SUB_TITLE}>
          Not Available
        </WsTypography>
      ) : (
        <RecruiterAvatarGroup list={list} />
      )}
    </Stack>
  </Grid>
);
